<app-page-header
  title="FAQs verwalten"
  subtitle="Aktualisiere häufig gestellte Fragen und halte deine Kunden auf dem Laufenden."
  icon="help_outline"
  [showBackButton]="true"
  variant="gradient">
</app-page-header>

<div class="nlc-container nlc-slide-up">
  <div class="">
    <div class="nlc-card faq-form-card">
      <div class="card-header-alignment">
        <div class="nlc-icon-visual">
          <mat-icon>edit_note</mat-icon>
        </div>
        <div>
          <h2 class="nlc-heading-3">
            {{ editingFaq ? 'FAQ bearbeiten' : 'Neue FAQ hinzufügen' }}
          </h2>
          <p class="nlc-caption" style="line-height: 0;">
            Fülle die Felder aus und speichere deine Änderungen.
          </p>
        </div>
      </div>

      <form [formGroup]="faqForm" (ngSubmit)="saveFaq()" class="faq-form">
        <mat-form-field appearance="outline" class="nlc-field">
          <mat-label>Frage</mat-label>
          <textarea matInput formControlName="question" required rows="1"></textarea>
        </mat-form-field>
        <mat-form-field appearance="outline" class="nlc-field">
          <mat-label>Antwort</mat-label>
          <textarea matInput formControlName="answer" required rows="3"></textarea>
        </mat-form-field>
        <div class="faq-form-actions">
          <button
            mat-flat-button
            color="primary"
            class="nlc-button nlc-button-primary nlc-button-large"
            style="font-size: 15px;"
            type="submit"
          >
            <mat-icon>save</mat-icon>
            {{ editingFaq ? 'FAQ aktualisieren' : 'FAQ hinzufügen' }}
          </button>
          <button
            mat-button
            type="button"
            class="nlc-button nlc-button-text"
            (click)="cancelEdit()"
            *ngIf="editingFaq"
          >
            <mat-icon>close</mat-icon>
            Abbrechen
          </button>
        </div>
      </form>
    </div>

    <div class="nlc-card faq-table-card">
            <div class="card-header-alignment">

        <div class="nlc-icon-visual">
          <mat-icon>library_books</mat-icon>
        </div>
        <div>
          <h2 class="nlc-heading-3">FAQ Übersicht</h2>
          <p class="nlc-caption" style="line-height: 0;">
            Bearbeite oder lösche bestehende Fragen.
          </p>
        </div>
      </div>
      <div class="table-wrapper">
        <table mat-table [dataSource]="(faqs$ | async) ?? []" class="nlc-faq-table">
          <ng-container matColumnDef="question">
            <th mat-header-cell *matHeaderCellDef class="nlc-table-header-cell">
              Frage
            </th>
            <td mat-cell *matCellDef="let faq" class="nlc-table-cell">
              {{ faq.question }}
            </td>
          </ng-container>

          <ng-container matColumnDef="answer">
            <th mat-header-cell *matHeaderCellDef class="nlc-table-header-cell">
              Antwort
            </th>
            <td mat-cell *matCellDef="let faq" class="nlc-table-cell answer-cell">
              {{ faq.answer }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef class="nlc-table-header-cell actions-header">
              Aktionen
            </th>
            <td mat-cell *matCellDef="let faq" class="nlc-table-cell actions-cell">
              <button mat-icon-button class="nlc-icon-button" (click)="startEdit(faq)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button color="warn" class="nlc-icon-button" (click)="deleteFaq(faq.id)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns" class="nlc-table-header-row"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="nlc-table-row"></tr>
        </table>
      </div>
    </div>
  </div>
</div>
